import type { RouteObject } from "react-router-dom";

export const forecastingDashboardRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Forecasting dashboard" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ForecastingDashboardPage } =
            await import("./forecasting-dashboard-page");
          return { Component: ForecastingDashboardPage };
        },
      },
    ],
  },
];
